import { useCallback, useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store';
import { onSignOut } from 'store/auth/reducers';
import { ToastManager } from 'utils/toast';

import { useSession } from './useSession';
import { useSignOut } from './useSignOut';

export function useTerminatedCheck() {
  const { t } = useTranslation();
  const { isSessionLoading, error } = useSession();

  const dispatch = useAppDispatch();
  const signOut = useSignOut();
  const hasHandledTerminationRef = useRef(false);

  const check = useCallback(() => {
    if (hasHandledTerminationRef.current) return;

    if (isSessionLoading) return;

    if (!error) return;

    if (error.message !== 'ACCOUNT_HAS_BEEN_TERMINATED') return;

    hasHandledTerminationRef.current = true;

    ToastManager.error(t('errors:api.ACCOUNT_HAS_BEEN_TERMINATED'), { id: 'ACCOUNT_TERMINATION' });

    // Sign the user out client-side immediately - don't wait on the logout
    // request to settle, so the auth guard redirects before any further action is possible.
    dispatch(onSignOut());

    signOut(undefined, false);
  }, [dispatch, error, isSessionLoading, signOut, t]);

  useEffect(() => {
    check();
  }, [check]);
}
